import '@babel/polyfill';
import 'array-from-polyfill';
import Vue from 'vue';
import VueTouchEvents from 'vue2-touch-events';
import App from './App';
import router from './core/router';
import store from './core/store';
import iframeChannel from './core/iframe-channel';

// import { ROUTE_NAMES, ROUTE_QUERY_PARAMS } from './core/config';


import SolidButton from './components/rb-button-solid';
import OutlineButton from './components/rb-button-outline';
import NinjaLoader from './components/ninja-loader';
import Icon from './components/rb-icon';

if (!window.UnifiedLoginSDK) {
  window.UnifiedLoginSDK = {};
}

Vue.config.productionTip = false;

Vue.use(VueTouchEvents);

Vue.component('solid-button', SolidButton);
Vue.component('outline-button', OutlineButton);
Vue.component('icon', Icon);
Vue.component('ninja-loader', NinjaLoader);

const main = new Vue({
  router,
  store,
  render: h => h(App),
});

// must be set before the next script runs
window.iFrameResizer = iframeChannel.getIframeResizerConfig();

import 'iframe-resizer/js/iframeResizer.contentWindow'; // eslint-disable-line

main.$mount('#app');
